<template>
  <div class="notice-list" :class="{ no_border: noBorder }">
    <div class="list_title" >
      <div class="title_box">
        <img src="@/assets/images/export.png" class="list_title_img" />
        <div class="list_title_text">下载中心</div>
      </div>
    </div>
    <img  :src="listData[0].picture" class="list_big_image" />
    <ul class="content-box">
      <li v-for="(item, index) in listData" :key="index" v-if="index < 2">
        <a
          :href="item.titleurl ? item.titleurl : `${context}/frontend/showNews.html?hashcode=${item.hashcode}`"
          target="_blank"
          :class="{ isRed: item.redtitle == '是' }"
          @mouseover="f(item.title)" @mouseleave="h()"
        >
          <span class="news_title">{{ item.title }}</span>
          <span class="news_time">{{ item.publishTime | formaTime(showYear) }}</span>
        </a>
      </li>
    </ul>
   <p class="more"><a :href="getHref(menu)">+more</a></p>
  </div>
</template>

<script>
import { getHref } from '@/utils';
export default {
  props: ['listData','menu'],
  filters: {
    formaTime: function(value, showYear = false) {
      let time = value.split('-');
      if (showYear) {
        return time[0] + '-' + time[1] + '-' + time[2];
      }
      return time[1] + '-' + time[2];
    },
    getDay: function(value) {
      let time = value.split('-');
      return time[2];
    },
    getMoth: function(value) {
      let time = value.split('-');
      return time[0] + '-' + time[1];
    },
    newsContent: function(value) {
      let div = document.createElement('div');
      div.innerHTML = value;
      return div.innerText.trim();
    },
  },
  methods: {
    getHref,
    f(str){
        let full=document.getElementById("fullTitleShow")
        if(full==null){
            full=document.createElement('div');
            full.id="fullTitleShow"
            full.innerHTML=str
            full.style.position="absolute"
            full.style.left=window.event.pageX+"px"
            full.style.top=window.event.pageY+"px"
            full.style.backgroundColor="white"
            full.style.padding="10px"
            full.style.border="1px solid black"
            full.style.zIndex=10000
            document.body.appendChild(full);
        }
    },
    h(){
        let full=document.getElementById("fullTitleShow")
        if(full!=null){
            document.body.removeChild(full)
        }
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variable.scss';
.notice-list {
  .list_title {
    height: 36px;
    margin:12px 12px 0;
    border-bottom: 2px solid #ccc;
    position: relative;
    display: flex;
    flex-direction: row;
    .title_box {
      height: 36px;
      border-bottom: 2px solid  $text_theme_color;
      display: flex;
      flex-direction: row;
      align-items: center;
      .list_title_text {
        color: $text_theme_color;
        font-size: 16px;
        font-weight: 600;
        margin-right:6px;
      }
      .list_title_img{
        width: 16px;
        height: 16px;
        margin:0 6px;
      }
    }
  }
  .content-box {
    padding: 16px 16px 8px 16px;
    cursor: pointer;
    .time_box {
      width: 55px;
      height: 50px;
      background: $text_theme_color;
      color: #fff;
      text-align: center;
      float: left;
      div {
        font-size: 18px;
        font-weight: 700;
        padding-top: 7px;
      }
      p {
        font-size: 14px;
      }
    }
    .news_box {
      margin-left: 70px;
      font-size: 14px;
      div {
        @include overLine(1);
        color: #333;
        font-weight: 700;
      }
      p {
        margin-top: 3px;
        color: #666;
        @include overLine(2);
        max-height: 30px;
        overflow: hidden;
      }
    }
    .news_box:hover {
      a {
        color: $text_theme_color;
      }
    }
  }
  ul {
    padding: 0 10px;
    li {
      a {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        padding: 8px 0;
        color: #333;
        .news_title {
          @include overLine(1);
          font-size: 14px;
          width: 80%;
          &:before {
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 6px;
            margin-right: 5px;
            /* margin-top: -5px; */
            content: '';
            background: $text_theme_color;
            transform: scale(0.8);
          }
        }
        .news_time {
          width: 14%;
          font-size: 14px;
          align-self: flex-end;
          text-align: end;
        }
        &:hover {
          color: $text_theme_color;
        }
      }
    }
  }
}
.list_big_image {
  width: 90%;
  height: 187px;
  margin-top:24px;
  margin-left: 5%;
}
.isRed {
  color: $text_theme_color !important;
  span {
    color: $text_theme_color !important;
  }
}
.more {
  text-align: right;
  font-size: 14px;
  padding-right: 10px;
  // font-weight: bold;
  &.top {
    position: absolute;
    top: 165px;
    right: 0px;
  }
  a {
    color: $text_theme_color!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/export/index.vue